import { claimIdentity, IUserSecurity } from './user-security';

export function getClaimsWrapper(claims: { [key: string]: string }) {
  return new UserSecurity(claims);
}

class UserSecurity implements IUserSecurity {
  private userClaims: { [key: string]: string };

  constructor(claims: { [key: string]: string }) {
    this.userClaims = claims;
  }

  public claimExists(claimName: string): boolean {
    return this.userClaims[claimName] !== undefined;
  }

  public claim(claimName: string): string {
    return this.userClaims[claimName] ?? '';
  }

  public claimIsTrue(claimName: string): boolean {
    return this.userClaims[claimName] === 'true';
  }

  public hasRole(roleName: string): boolean {
    return this.claimIsTrue(`role-${roleName}`);
  }

  public isSupplier() {
    return this.claimIsTrue(claimIdentity.supplier);
  }

  public isPowerUser(): boolean {
    return this.claimIsTrue(claimIdentity.frameConfigPowerUser);
  }

  public isAdmin(): boolean {
    return this.claimIsTrue(claimIdentity.admin);
  }

  supplierId() {
    return this.getUserSupplierId() ?? 0;
  }

  supplierGuid() {
    return this.getUserSupplierGuid() ?? '00000000-0000-0000-0000-000000000000';
  }

  public getUserSupplierId(): number | undefined {
    if (this.isSupplier()) {
      const val = parseInt(this.userClaims[claimIdentity.supplierId] ?? '0');

      return isNaN(val) ? undefined : val;
    }
    return undefined;
  }

  public getUserSupplierGuid(): string | undefined {
    if (this.isSupplier()) {
      return this.userClaims[claimIdentity.supplierId];
    }
    return undefined;
  }
}
